import {ChangeEvent, FC} from 'react';
import {TextInput} from 'features/registration/ui/components/TextInput';
import {getProfileEmailError} from '../../model/emailValidation';
import styles from './CertificateEmailStep.module.css';

type Props = {
	value: string;
	onChange: (email: string) => void;
};

export const CertificateEmailStep: FC<Props> = ({value, onChange}) => {
	const error = getProfileEmailError(value);

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		onChange(event.target.value);
	};

	return (
		<div className={styles.root}>
			<div className={styles.intro}>
				<h2 className={styles.title}>Укажите почту</h2>
				<p className={styles.subtitle}>Отправим туда справку</p>
			</div>

			<div className={styles.field}>
				<TextInput
					name="certificateEmail"
					type="email"
					className={styles.input}
					value={value}
					placeholder="name@example.com"
					autoComplete="email"
					inputMode="email"
					autoFocus
					aria-invalid={Boolean(error)}
					onChange={handleChange}
					onClear={() => onChange('')}
				/>
				{error ? <p className={styles.error}>{error}</p> : null}
			</div>
		</div>
	);
};
